<template>
  <div class="modal fade">
  <v-dialog :value="value" content-class="edit-post-modal" @input="$emit('input')" max-width="900px">
    <v-layout>
      <v-flex xs12>
        <v-card v-if="postData">
          <v-toolbar dense class="elevation-2">
            <v-toolbar-title>Edit Draft</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon><v-icon @click="closeModal">close</v-icon></v-btn>
          </v-toolbar>
          <v-form id="campaignForm">
            <v-card-title primary-title>
              <v-text-field
                :rules="[rules.required]"
                name="campaignName"
                v-model="postData.campaignName"
                :disabled="typeof postData.submittedCampaignName === 'string'"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <div class="mb-2" v-if="postData.author">
                <v-row cols="12">
                  <v-col xs="6">
                    <v-avatar size="35" color="grey lighten-4">
                      <!-- <img
                        class="elevation-6"
                        v-bind:src="paserAudienceImageUrl(influencerData.audience)"
                        alt="avatar"
                        v-if="influencerData.audience"
                      > -->
                      <img
                        class="elevation-6"
                        v-bind:src="paserImageUrl(postData.author.picture)"
                        alt="avatar"
                      >
                    </v-avatar>
                    <a
                      :href="'https://www.tiktok.com/@' + postData.author.tiktokHandle"
                      target="_blank"
                      v-if="postData.author.tiktokHandle"
                    ><img src="/static/img/tiktok-32.png" width="20px" /> @{{postData.author.tiktokHandle}}</a>
                    <a
                      :href="'https://youtube.com/' + postData.author.youtubeHandle"
                      target="_blank"
                      v-else-if="postData.author.youtubeHandle"
                    ><v-icon>mdi-youtube</v-icon> @{{postData.author.youtubeHandle}}</a>
                    <a
                      :href="'https://www.xiaohongshu.com/user/profile/' + postData.author.xhsHandle"
                      target="_blank"
                      rel="noopener noreferrer"
                      v-else-if="postData.author.xhsHandle"
                    >{{postData.author.xhsHandle}}</a>
                    <a
                      :href="'https://www.linkedin.com/in/' + postData.author.linkedinHandle"
                      target="_blank"
                      rel="noopener noreferrer"
                      v-else-if="postData.author.linkedinHandle"
                    ><v-icon color="#0A66C2" small>mdi-linkedin</v-icon> @{{postData.author.linkedinHandle}}</a>
                    <a
                      :href="'https://x.com/' + (postData.author.twitterHandle || postData.author.instagramHandle)"
                      target="_blank"
                      rel="noopener noreferrer"
                      v-else-if="postData.type === 'twitter' || postData.author.twitterHandle"
                    ><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true"> @{{postData.author.twitterHandle || postData.author.instagramHandle}}</a>
                    <a
                      :href="'https://instagram.com/' + postData.author.instagramHandle"
                      target="_blank"
                      v-else
                    ><v-icon color="#000000" small>mdi-instagram</v-icon> @{{postData.author.instagramHandle}}</a>
                  </v-col>
                  <v-col xs="6" class="text-right">
                    <v-chip
                      color="primary"
                      v-if="postData.type"
                    >
                      {{ postData.type | platformDisplayName }}
                    </v-chip>
                  </v-col>
                </v-row>
              </div>
              <v-row>
                <v-col :md="(postAbuseHistory && clientReportAbuse.length > 0) ? 8 : 12" xs="12">
                  <v-container grid-list-sm container--fluid style="margin-bottom:20px;">
                    <v-layout
                      v-if="viewImages.length === 0"
                      style="height: 100%;"
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <p>No Media to show</p>
                    </v-layout>
                    <v-layout row wrap>
                      <draggable v-model="viewImages" @start="drag=true" @end="dragEnd" style="width:100%;" class="row align-center justify-center" >
                        <v-flex class="mb-3" v-for="(img,i) in viewImages" :key="i" md4 xs12>
                          <div v-if="isMissingMedia(img)">
                            <v-alert type="warning" outlined>
                              This media file is missing. Remove it and upload the original file again.
                            </v-alert>
                            <v-btn text block dark color="red" @click="deleteImages(i)">
                              <v-icon dark>delete</v-icon>Remove
                            </v-btn>
                          </div>
                          <div v-else-if="img.publicID && img.isvideo">
                            <v-card text tile>
                              <v-hover>
                                <custom-media-v2
                                  :media="campaignHelper.customPostMediaConfig(img)"
                                />
                              </v-hover>
                            </v-card>
                            <div class="text-center mt-2">
                              <div class="d-flex">
                                <v-btn small dark color="red" @click="deleteImages(i)">
                                  <v-icon dark>delete</v-icon>Remove
                                </v-btn>
                                <btn-download :url="img.url" className="mt-0"></btn-download>
                              </div>
                            </div>
                          </div>
                          <v-card text tile class="elevation-0" v-else>
                            <!-- Display image-->
                            <div v-if="!img.isvideo">
                              <v-img
                                :src="img.url"
                                :lazy-src="img.url"
                                aspect-ratio="1"
                                class="grey lighten-2 mx-auto"
                                v-if="!img.isvideo && !img.publicID"
                              >
                                <!-- <v-expand-transition>
                                  <v-layout
                                    v-if="hover"
                                    class="transition-fast-in-fast-out grey blue-grey lighten-5 darken-2 v-card--reveal display-3 white--text"
                                    style="height: 100%;"
                                    fill-height
                                    align-center
                                    ma-0
                                  >
                                    <v-btn small dark color="red" @click="deleteImages(i)">
                                      <v-icon dark>delete</v-icon>Remove
                                    </v-btn>
                                  </v-layout>
                                </v-expand-transition> -->
                              </v-img>
                              <div
                              class="cursor-pointer"
                              v-if="img && !img.isvideo && img.publicID">
                                <custom-media-v2
                                  :media="campaignHelper.customPostMediaConfig(img, {})"
                                />
                              </div>
                              <div class="text-center mt-2">
                                <div class="d-flex">
                                  <v-btn class="mr-2" small dark color="red" @click="deleteImages(i)">
                                    <v-icon dark>delete</v-icon>Remove
                                  </v-btn>
                                  <btn-download :url="img.url" className="mt-0"></btn-download>
                                </div>
                              </div>
                            </div>
                            <!-- Display video-->
                            <v-card text v-if="img.isvideo" class="elevation-8">
                              <v-card-text>
                              <video id="previewVideo" width="100%" controls>
                                <source :src="img.url" type="video/mp4">
                              </video>
                              </v-card-text>
                              <div class="px-2">
                                <btn-download :url="img.url" v-if="img.type === 'video/quicktime'"></btn-download>
                              </div>
                              <v-card-actions>
                              <v-btn text block dark color="red" @click="deleteImages(i)">
                                <v-icon dark>delete</v-icon>Remove
                              </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                        </v-flex>
                      </draggable>
                    </v-layout>
                  </v-container>
                  <v-btn
                    :loading="loading"
                    :disabled="loading"
                    color="blue-grey"
                    class="white--text"
                    @click="$refs.mediaUpload.click()"
                    block
                  >
                    Add Media
                    <v-icon float-right dark>cloud_upload</v-icon>
                  </v-btn>
                  <input
                    type="file"
                    name="images"
                    style="display: none"
                    ref="mediaUpload"
                    id="fileToUpload"
                    accept="image/*, video/*"
                    multiple
                    @change="prepareUpload"
                  >
                  <v-divider></v-divider>
                  <div v-if="isCaptionText">
                    <v-textarea                  
                      filled
                      auto-grow
                      rows="4"
                      name="captionText"
                      label="Current Caption"
                      :value="postData.defaultCaptionText"
                      counter
                      disabled
                    ></v-textarea>
                    <v-textarea                  
                      outlined
                      auto-grow
                      rows="4"
                      name="captionText"
                      :label="captionLabel"
                      :rules="[rules.length(2200)]"
                      v-model="postData.captionText"
                      counter
                    ></v-textarea>
                  </div>
                  <div v-if="isVideoLink">
                    <v-text-field         
                      filled   
                      clearable
                      name="vdoLink"
                      type="text"
                      label="Link (If your file size is bigger than 100mb or the video fails to upload, please insert a video/drive link here)"
                      persistent-hint
                      v-model="postData.vdoLink"
                      >
                    </v-text-field>
                  </div>
                  <div v-if="isRemark">
                    <div class="kobe-remark-editor-label">Kobe Remark</div>
                    <sun-editor
                      class="kobe-remark-editor"
                      :content="postData.remark || ''"
                      width="100%"
                      height="180"
                      source="post"
                      @contentChanged="postData.remark = $event"
                      @loadingDialogOpen="loading = true"
                      @loadingDialogClose="loading = false"
                    />
                  </div>
                  <div class="body-1" v-if="isHashTag">
                    <v-textarea             
                      outlined
                      auto-grow        
                      rows="4"
                      name="mandatoryHashtag"
                      label="Mandatory Hashtag & Mentions"
                      v-model="postData.mandatoryHashtag"     
                      counter       
                      >
                    </v-textarea>                                   
                  </div>
                  <div class="body-1" v-if="isCallToActionLinks">
                    <v-textarea             
                      outlined
                      auto-grow        
                      rows="4"          
                      name="callToActionLinks"
                      label="Call to Action Links"        
                      v-model="postData.callToActionLinks"     
                      counter       
                      >
                    </v-textarea>                                   
                  </div>
                  <!-- <v-dialog
                    ref="dateDialog"
                    v-model="datePickerDialog"
                    :return-value.sync="postData.postDate"
                    persistent
                    width="290px"
                    v-if="showSetDateOption"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="postData.postDate"
                        label="Pick a Date that this post should publish"
                        append-icon="event"
                        name="postDate"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="postData.postDate" scrollable :min="todayDatePick">
                      <v-spacer></v-spacer>
                      <v-btn text color="secondary" @click="datePickerDialog = false">Cancel</v-btn>
                      <v-btn text color="secondary" @click="$refs.dateDialog.save(postData.postDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-dialog
                    ref="endDateDialog"
                    v-model="endDatePickerDialog"
                    :return-value.sync="postData.postDateEnd"
                    persistent
                    width="290px"
                    v-if="showSetDateOption"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="postData.postDateEnd"
                        label="Pick a Date that this post should publish latest by"
                        append-icon="event"
                        name="postDateEnd"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="postData.postDateEnd" scrollable :min="postData.postDate">
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="endDatePickerDialog = false">Cancel</v-btn>
                      <v-btn color="secondary" @click="$refs.endDateDialog.save(postData.postDateEnd)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog> -->
                </v-col>
                <v-col md="4" xs="12" v-if="postAbuseHistory && clientReportAbuse.length > 0">
                  <v-expansion-panels class="report-abuse-section-edit">
                    <v-expansion-panel v-for="(item, i) in clientReportAbuse" :key="i">
                      <v-expansion-panel-header>
                        <div class="subtitle-1" color="red lighten-4">
                          <v-icon color="deep-orange">report_problem</v-icon>
                          Reported Abuse
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text class="grey lighten-3">
                            <h4>Reasons for Non-Approval</h4>
                            <p>
                              <ol>
                                <li v-for="r in item.reasons" :key="r">{{r}}</li>
                              </ol>
                            </p>
                            <h4>Comments for Abuse:</h4>
                            <p>
                              {{item.comment}}
                            </p>
                            <div class="text-xs-right caption font-weight-italic">{{formatDate(item.date)}}</div>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="deletePost()" dark color="red" v-if="allowDelete">Delete Post</v-btn>
              <v-btn @click="submit" dark color="green">Save Changes</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.native="closeModal" text>Close</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
      <v-dialog v-model="loading" hide-overlay persistent width="250">
        <v-card color="primary" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-dialog>
  </div>
</template>

<script>
import { isMissingPostMedia } from './postMedia';
import { mapState } from 'vuex';
import config from '@/config';
import postApi from './postApi';
import { getEditPostErrorMessage, getPendingImageChanges, serializeViewImages } from './editPostPayload';
import moment from 'moment';
import draggable from 'vuedraggable';
import btnDownload from '@/components/scoped/custom/BtnDownload.vue';
import CustomMediaV2 from '../../scoped/custom/CustomMediaV2';
import campaignHelper from '../Campaign/campaignHelper';
// import campaignAPIs from '../Campaign/campaignAPIs';
import influencerAPIs from '../Influencer/influencerAPIs';
import utils from '@/utils';
import SunEditor from '../../editor/sunEditor';
export default {
  components: {
    draggable,
    btnDownload,
    CustomMediaV2,
    SunEditor
  },
  props: {
    value: Boolean,
    post: Object,
    userObj: Object,
    postAbuseHistory: Boolean
  },
  data() {
    return {
      loading: false,
      postData: null,
      removed: [],
      imageChanges: [],
      viewImages: [],
      mediaUploadDialog: false,
      datePickerDialog: false,
      endDatePickerDialog: false,
      rules: {
        length: len => v => (v || '').length <= len || `Character Length should not more than ${len}`,
        required: v => !!v || 'This field is required'
      },
      images: [],
      showSetDateOption: true,
      todayDatePick: '',
      // allowedExtensions: /(\.jpg|\.jpeg|\.png|\.gif|\.mp4)$/i
      allowedExtensions: /(image\/.|video\/.)$/i,
      allowDelete: true,
      influencerRole: config.userRoles.INFLUENCER,
      campaignHelper,
      cldConfig: config.cldConfig,
      cld: null,
      cldFolderPath: 'POST SUBMISSIONS',
      clientReportAbuse: [],
      clientReportAbuseData: [],
      influencerData: {}
    };
  },
  computed: {
    ...mapState({
      campaign: state => state.campaign.campaignDetail,
      cldSignature: state => state.campaign.cldSignature
    }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    isVideoLink() {
      return this.postData.type === 'story' ||
      this.postData.type === 'video' ||
      this.postData.type === 'reel' ||
      this.postData.type === 'tiktok' ||
      this.postData.type === 'youtube' ||
      this.postData.type === 'facebook' ||
      this.postData.type === 'linkedin'
    },
    isRemark() {
      return this.currentUserRole <= config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.ACCOUNT_MANAGER
    },
    isHashTag() {
      return (this.postData.mandatoryHashtag || this.postData.mandatoryHashtag === '') && (this.currentUserRole <= config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.ACCOUNT_MANAGER)
    },
    isCallToActionLinks() {
      return (this.postData.callToActionLinks || this.postData.callToActionLinks === '') && (this.currentUserRole <= config.userRoles.AD_STRATEGIST || this.currentUserRole === config.userRoles.ACCOUNT_MANAGER)
    },
    isCaptionText() {
      return this.postData.captionText || this.postData.captionText === ''
    },
    captionLabel() {
      return this.postData.type === 'story' ? 'Story Caption' : 'Caption'
    }
  },
  watch: {
    post(newVal) {
      this.postData = newVal || null;
      this.images = this.postData.images;
      this.removed = [];
      this.imageChanges = [];
      this.viewImages = [...this.postData.images];
      if (this.userObj.role === config.userRoles.INFLUENCER && this.postData.status >= config.postStatus.CLIENT_PENDING) {
        this.allowDelete = false;
      }
      this.clientReportAbuseData = newVal.reportAbuse
      this.clientReportAbuse = newVal.reportAbuse ? newVal.reportAbuse.filter(item => newVal.draftId ? (item.draftPostId === newVal.draftId) : false) : []
      this.getInfluencerData(newVal.influencerID)
      this.refreshMediaViews()
      if (this.postData.captionText) this.setCurrentCaptionText()
      if (!this.postData.callToActionLinks) {
        this.loadCampaign(this.postData)
      }
    },
    viewImages(nVal) {
      this.viewImages = nVal
      // console.log('🚀 ~ file: EditPost.vue ~ line 249 ~ viewImages ~ this.viewImages', this.viewImages)
      // console.log('image changes', this.imageChanges)
    },
    value(newVal) {
      if (newVal) {
        /* eslint-env jquery */
        setTimeout(() => {
          let modalHeight = $('.edit-post-modal').height()
          let reposeAbuseHeight = modalHeight - 210
          var element = document.querySelector('.report-abuse-section-edit');
          element.setAttribute('style', `max-height:${reposeAbuseHeight}px!important;overflow-y:auto;padding:2px;`)
        }, 1000)
      }
    }
  },
  mounted() {
    this.cld = window.cloudinary.Cloudinary.new({ cloud_name: this.cldConfig.CLOUD_NAME });
    if (this.userObj.role === config.userRoles.INFLUENCER) {
      this.showSetDateOption = false;
    }
    this.todayDatePick = moment().format('YYYY-MM-DD');
  },
  methods: {
    isMissingMedia(media) {
      return isMissingPostMedia(media, this.imageChanges)
    },
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      this.viewImages.sort((a, b) => a.index - b.index);
      let index = this.viewImages.length > 0 ? (this.viewImages[this.viewImages.length - 1].index || 0) : 0;
      uploadedFiles.forEach(element => {
        let type = element.type.split('/')[0]
        if (type !== 'video' && type !== 'image') {
          this.$swal('File Type Not Supported, Please select a video or an image')
        } else if (type === 'video') {
          const reader = new FileReader()
          const vm = this;
          reader.onload = function() {
            let blog = new Blob([reader.result], {type: element.type});
            let url = URL.createObjectURL(blog);
            vm.viewImages.push({
              index: index,
              url: url,
              type: element.type,
              isvideo: true,
              isNew: true
            })
            vm.imageChanges.push({
              index,
              element,
              url: url
            });
          }
          reader.readAsArrayBuffer(element);
        } else {
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = e => {
            this.viewImages.push({
              url: e.target.result,
              index: ++index,
              isNew: true
            });
            this.imageChanges.push({
              index,
              element,
              url: e.target.result
            });
          };
        }
      });
    },
    async deleteImages(pos) {
      let img = this.viewImages[pos];
      this.removed.push(img.url);
      let delImages = Object.assign([], this.viewImages)
      delImages.splice(pos, 1);
      let index = 0
      this.viewImages = []
      setTimeout(() => {
        for (let img of delImages) {
          img.index = index
          this.viewImages.push(img)
          index += 1
        }
        this.imageChanges = this.imageChanges.filter(i => i.url !== img.url);
        // console.log('🚀 ~ file: EditPost.vue ~ line 310 ~ deleteImages ~ this.imageChanges', this.imageChanges)
      }, 500)
    },
    submit() {
      let editData = this.buildFormData();
      // Log the key/value pairs
      // for (var pair of editData.entries()) {
      //   console.log(pair[0] + ' - ' + pair[1]);
      // }
      this.$swal({
        title: 'Do you want to save changes to this post?',
        type: 'question',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return postApi
            .editPost(this.postData._id, editData)
            .then(response => {
              return response;
            })
            .catch(error => {
              this.$swal.showValidationError(getEditPostErrorMessage(error));
              return false;
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.$swal({
            title: 'Submitted successfully',
            type: 'success'
          }).then(() => {
            this.$emit('input');
            this.$emit('postUpdated');
          });
        }
      });
    },
    buildFormData() {
      let form = document.getElementById('campaignForm');
      let formData = new FormData(form);
      formData.append('removed', JSON.stringify(this.removed));
      // const medias = this.imageChanges.map(m =>
      //   Object.assign({}, {
      //     publicID: m.publicID,
      //     url: m.file,
      //     type: m.type
      //   })
      // )
      // formData.append('images', JSON.stringify(medias));
      // formData.append('viewImages', JSON.stringify(this.viewImages));
      // Make sure the images appended at bottom
      formData.delete('images');
      if (this.isRemark) {
        formData.delete('remark');
        formData.append('remark', this.postData.remark || '');
      }
      const pendingImageChanges = getPendingImageChanges(this.imageChanges)
      for (let val of pendingImageChanges) {
        formData.append('images', val.element, val.element.name);
      }
      formData.append('viewImages', JSON.stringify(serializeViewImages(this.viewImages, this.imageChanges)));
      return formData;
    },
    deletePost() {
      this.$swal({
        title: 'Do you want to delete this post?',
        type: 'question',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.loading = true;
          postApi
            .deletePost(this.postData.originalPost || this.postData._id)
            .then(() => {
              this.loading = false;
              this.$swal({
                title: 'Deleted successfully',
                type: 'success'
              }).then(() => {
                this.$router.go();
              });
            })
            .catch(error => {
              this.loading = false;
              this.$swal({
                text: error,
                type: 'error'
              });
            });
        }
      });
    },
    closeModal() {
      this.$emit('input')
      this.pauseVideo()
    },
    pauseVideo() {
      let video = document.getElementById('previewVideo');
      if (video) { video.pause(); }
    },
    processUpload(error, result) {
      if (!error && result && result.event === 'success') {
        let INFO = result.info
        this.imageChanges.push({
          publicID: INFO.public_id,
          file: INFO.secure_url,
          type: INFO.resource_type,
          preview: {
            thumbnail: INFO.thumbnail_url,
            src: INFO.thumbnail_url,
            name: INFO.original_filename,
            format: INFO.format
          }
        });
        let index = this.viewImages.length > 0 ? this.viewImages[this.viewImages.length - 1].index : 0;
        this.viewImages.push({
          url: INFO.secure_url,
          publicID: INFO.public_id,
          index: index,
          type: INFO.resource_type,
          isvideo: INFO.resource_type === 'video',
          new: true
        })
      } else if (error && error.status && error.status.includes('maximum allowed (300 MB)')) {
        this.myWidget.close()
        this.$swal({
          type: 'error',
          text: error.statusText
        });
        return
      } else if (error) {
        this.$swal({
          type: 'error',
          text: 'Failed to multiple contents'
        });
        return
      }
    },
    openCloudinaryUpload() {
      // this.loadingDialog = true
      let username = 'N/A'
      let socialData = {}
      if (this.influencerData.tiktok) {
        socialData = this.influencerData.tiktok
        username = socialData.tiktokHandle || 'N/A'
      } else if (this.influencerData.youtube) {
        socialData = this.influencerData.youtube
        username = socialData.youtubeHandle || 'N/A'
      } else if (this.influencerData.xiaohongshu) {
        socialData = this.influencerData.xiaohongshu
        username = socialData.xhsHandle || socialData.xhsFullname || 'N/A'
      } else if (this.influencerData.linkedin) {
        socialData = this.influencerData.linkedin
        username = socialData.linkedinHandle || 'N/A'
      } else if (this.influencerData.instagram) {
        socialData = this.influencerData.instagram
        username = socialData.instagramHandle || 'N/A'
      }
      this.openCloudinaryWidget(`${this.cldFolderPath}/@${utils.func.escapeCldSpecialChars(username)}`)
    },
    async openCloudinaryWidget(folder) {
      // init cloudinary object
      let tags = [this.postData.campaignName, 'tmp']
      await this.$store.dispatch('campaign/getCldSignature', {
        filters: {
          folder,
          source: 'uw', // upload widget
          tags
        }
      })
      this.myWidget = window.cloudinary.createUploadWidget(
        { cloudName: this.cldConfig.CLOUD_NAME,
          uploadPreset: this.cldConfig.UPLOAD_PRESET,
          folder,
          tags,
          thumbnailTransformation: [{ width: 320, height: 320, crop: 'fill' }],
          sources: ['local', 'url', 'google_drive', 'facebook', 'instagram'],
          api_key: this.cldConfig.API_KEY,
          uploadSignature: this.cldSignature.signature,
          uploadSignatureTimestamp: this.cldSignature.timestamp,
          maxFileSize: 314572800, // 300 MB limit
          prepareUploadParams: async (cb, params) => {
            // if headers changed especially for google drive, regenerate signature
            params = [].concat(params)
            for (let [index, param] of params.entries()) {
              if (param.headers) {
                await this.$store.dispatch('campaign/getCldSignature', {
                  filters: {
                    filename_override: param.filename_override,
                    folder: param.folder,
                    headers: param.headers,
                    source: 'uw',
                    tags,
                    timestamp: param.timestamp
                  }
                })
              }
              params[index] = Object.assign({}, {
                signature: this.cldSignature.signature
              })
            }
            cb(params.length === 1 ? params[0] : params)
          }
        },
        this.processUpload
      );
      this.myWidget.open()
    },
    getInfluencerData(influencerID) {
      influencerAPIs
        .getInfluencer(influencerID)
        .then(response => {
          this.influencerData = response;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY, HH:mm');
    },
    paserImageUrl(url) {
      if (!url) return null
      var newUrl = url.replace('http://imgp.socapi.icu/', location.origin + '/socapi').replace('https://imgp.socapi.icu/', location.origin + '/socapi')
      return newUrl
    },
    dragEnd() {
      this.drag = false
      this.refreshMediaViews()
    },
    refreshMediaViews() {
      // clear array objects to fix for cloudinary video cache
      const vm = this
      let tmpImages = Object.assign([], this.viewImages)
      this.viewImages = []
      setTimeout(() => {
        vm.viewImages = Object.assign(tmpImages)
      }, 0)
    },
    setCurrentCaptionText() {
      this.postData.defaultCaptionText = utils.func.refreshJSON(this.postData.captionText)
    },
    async loadCampaign(post) {
      await this.$store.dispatch('campaign/getCampaignDetail', post.campaignID)
      let hashTags = campaignHelper.getMandatoryHashtagMentions(this.campaign)
      if (hashTags) this.postData.mandatoryHashtag = hashTags
      if (this.campaign.callToActionLinks) this.postData.callToActionLinks = this.campaign.callToActionLinks || ''
      this.postData = utils.func.refreshJSON(this.postData)
    }
  }
};
</script>
<style>
.kobe-remark-editor-label {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  margin-bottom: 4px;
}

.kobe-remark-editor {
  margin-bottom: 16px;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// EditPost.vue?39adf16e